import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityViverosGrupoEspecieState,
  entityViverosGrupoEspecieAdapter
} from './entity-viveros-grupo-especie.state';
import { selectAllGruposEspecie } from '../entity-grupos-especie/grupos-especie.selectors';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } =
  entityViverosGrupoEspecieAdapter.getSelectors();

export const getError = (state: EntityViverosGrupoEspecieState): any =>
  state.error;

export const getIsLoading = (state: EntityViverosGrupoEspecieState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (
  state: EntityViverosGrupoEspecieState
): boolean => state.hasAddedSuccess;

export const selectViverosGrupoEspecieState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.viverosGrupoEspecie
);

export const selectAllViverosGrupoEspecie = createSelector(
  selectViverosGrupoEspecieState,
  selectAll
);
export const selectEntitiesViverosGrupoEspecie = createSelector(
  selectViverosGrupoEspecieState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectViverosGrupoEspecieError = createSelector(
  selectViverosGrupoEspecieState,
  getError
);

// MemoizedSelector<object,any>
export const selectViverosGrupoEspecieIsLoading = createSelector(
  selectViverosGrupoEspecieState,
  getIsLoading
);

export const selectViverosGrupoEspecieAddedSuccess = createSelector(
  selectViverosGrupoEspecieState,
  getHasAddedSuccess
);

export const selectViverosGrupoEspecieCurrentEmpresa = createSelector(
  selectAllViverosGrupoEspecie,
  selectCurrentEmpresa,
  (viverosGrupoEspecie, currentEmpresa) => {
    if (viverosGrupoEspecie && currentEmpresa) {
      return viverosGrupoEspecie.filter(
        (v) => v.entidad_productiva_id == currentEmpresa.id
      );
    } else {
      return [];
    }
  }
);

export const selectGruposEspecieViverosCurrentEmpresa = createSelector(
  selectViverosGrupoEspecieCurrentEmpresa,
  selectAllGruposEspecie,
  (vges, ges) => {
    let ret: string[] = [];
    if (vges && ges) {
      vges.forEach((vge) => {
        const ge = ges.find((g) => g.id == vge.id);
        ret.push(ge?.nombre);
      });
      return ret;
    } else {
      return [];
    }
  }
);
